// extracted by mini-css-extract-plugin
export default {"text":"GameModal_text__SJXK8","green":"GameModal_green__1VRk7","red":"GameModal_red__DZnMM","form":"GameModal_form__62dWh"};